var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.6403V13.6667C2 13.8534 2.14665 14 2.33329 14H4.35967C4.44633 14 4.53298 13.9667 4.59297 13.9L11.872 6.62769L9.37231 4.12804L2.09999 11.4004C2.03333 11.467 2 11.547 2 11.6403ZM13.805 4.69463C14.065 4.43466 14.065 4.01472 13.805 3.75476L12.2452 2.19497C11.9853 1.93501 11.5653 1.93501 11.3054 2.19497L10.0855 3.4148L12.5852 5.91446L13.805 4.69463Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.aee5057d06f8a11d92b26436257946e3.svg";
export { ForwardRef as ReactComponent };